import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [notes, setNotes] = useState([]);

  useEffect(() => { load(); }, []);
  const load = async () => {
    const { data } = await api.get("/notifications");
    setNotes(data);
  };

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  const remove = async (id) => {
    if (!confirm("Delete this notification?")) return;
    try {
      await api.delete(`/notifications/${id}`);
      toast.success("Deleted");
      load();
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-12 py-14 lg:py-20" data-testid="notifications-page">
      <p className="overline mb-4">Inbox</p>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-12">Notifications.</h1>

      {notes.length === 0 ? (
        <div className="border border-borderSubtle bg-white p-12 text-center">
          <p className="text-stone">Nothing yet. Order updates will appear here.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notes.map((n) => (
            <div key={n.id}
                 className={`border p-6 flex justify-between items-start gap-6 transition-colors ${n.read ? "bg-white border-borderSubtle" : "bg-white border-oxblood"}`}
                 data-testid={`notification-${n.id}`}>
              <div className="flex-1">
                {!n.read && <span className="overline text-oxblood block mb-2">New</span>}
                <p className="font-serif text-2xl mb-1">{n.title}</p>
                <p className="text-sm text-stone">{n.body}</p>
                <p className="text-[12px] text-stone font-mono mt-3 uppercase tracking-widest">
                  {new Date(n.created_at).toLocaleString()}
                </p>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                {!n.read && (
                  <button onClick={() => markRead(n.id)} className="overline text-oxblood hover:text-charcoal" data-testid={`mark-read-${n.id}`}>
                    Mark read
                  </button>
                )}
                <button
                  onClick={() => remove(n.id)}
                  className="text-stone hover:text-oxblood transition-colors"
                  data-testid={`delete-notification-${n.id}`}
                  aria-label="Delete notification"
                >
                  <Trash2 size={16} strokeWidth={1.5}/>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
